// extracted by mini-css-extract-plugin
export default {"mobile":"ProductSpotlightStatic_mobile__1ojoB","hero":"ProductSpotlightStatic_hero__1--2o","desktop":"ProductSpotlightStatic_desktop__LfApB"};